interface GridSkeletonProps {
  rows?: number;
  columns?: number;
  /** `bare` = legacy table; `v3` = rounded placeholders for View Grid card. */
  variant?: 'bare' | 'v3';
  /** Dark themed header row (v3 variant only). */
  showHeader?: boolean;
}

const HEADER_COL_KEYS = [
  'hdr-col-1',
  'hdr-col-2',
  'hdr-col-3',
  'hdr-col-4',
  'hdr-col-5',
  'hdr-col-6',
];

const GridSkeleton = ({
  rows = 1,
  columns = 12,
  variant = 'bare',
  showHeader = false,
}: GridSkeletonProps) => {
  const rowKeys = Array.from(
    { length: rows },
    (_, index) => `skeleton-row-${index}`
  );
  const colKeys = Array.from(
    { length: columns },
    (_, index) => `skeleton-col-${index}`
  );
  const headerCols = colKeys.slice(0, Math.min(columns, HEADER_COL_KEYS.length));

  const placeholderClass =
    variant === 'v3' ? 'placeholder rounded col-12' : 'placeholder col-12';

  return (
    <div className={variant === 'v3' ? 'v3-grid-skeleton-table' : undefined}>
      <table
        className="table table-hover m-0 placeholder-glow"
        style={{ tableLayout: 'fixed', width: '100%' }}
      >
        {showHeader && variant === 'v3' && (
          <thead>
            <tr className="v3-grid-skeleton-header">
              {headerCols.map((colKey) => (
                <th key={colKey} style={{ width: `${100 / columns}%` }}>
                  <span
                    className="placeholder rounded col-10 d-block mx-auto"
                    style={{ height: '0.85rem' }}
                  />
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {rowKeys.map((rowKey) => (
            <tr key={rowKey}>
              {colKeys.map((colKey) => (
                <td key={`${rowKey}-${colKey}`} style={{ width: `${100 / columns}%` }}>
                  <span className={placeholderClass} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GridSkeleton;
